import {Injectable} from '@angular/core';
import {BehaviorSubject,  Observable } from 'rxjs';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import { Coupon } from '../coupons-ums/coupon.model';
import { PaginatedResponse } from '../../shared/models/paginationResponse.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CouponsUmsService {
private readonly urlBase = '/api/coupons';

  constructor (private httpClient: HttpClient) {}

  getCoupons(params: { page: number; size: number; sortBy: string; dir: 'asc'|'desc',search?: string; }): Observable<PaginatedResponse<Coupon>> {
    let paramsToSend = new HttpParams()
      .set('page', String(params.page))
      .set('per_page', String(params.size));
    if (params.sortBy) paramsToSend = paramsToSend.set('sort', params.sortBy);
    if (params.dir)    paramsToSend = paramsToSend.set('dir', params.dir);
    if (params.search) paramsToSend = paramsToSend.set('q', params.search);
    return this.httpClient.get<PaginatedResponse<Coupon>>(this.urlBase, { params: paramsToSend }) .pipe(
      map((res:any) => ({
        ...res,
        data: res.data.map(c => ({
          ...c,
          start_at: c.start_at.replace(' ', 'T'),
          end_at:   c.end_at.replace(' ', 'T'),
        })),
      }))
    );;
  }

  saveCoupon(coupon: Coupon) {
    return this.httpClient.post(this.urlBase, coupon);
  }

  updateCoupon(coupon: Coupon) {
    return this.httpClient.put(this.urlBase + '/'+ coupon.id, coupon);
  }

  deleteCoupon(id: number) {
    return this.httpClient.delete(this.urlBase + '/'+ id);
  }

  lookforChildren(id: number): Observable<object> {
    return this.httpClient.get(this.urlBase + 'lookforChildren?id=' + id);
  }
}
